{
  "management": "Scorecard Management",
  "create_manage_scorecards": "Create and manage golf course scorecards",
  "create_new_scorecard": "Create New Scorecard",
  "edit_scorecard": "Edit Scorecard",
  "search_scorecards": "Search by course name or city...",
  "no_scorecards_found": "No scorecards found",
  "tee_sets": "Tee Sets",
  "course_info": "Course Info",
  "hole_config": "Holes",
  "tee_set_config": "Tee Sets",
  "review": "Review",
  "course_information": "Course Information",
  "number_of_holes": "Number of Holes",
  "use_current_location": "Use current location",
  "hole_configuration": "Hole Configuration",
  "auto_assign": "Auto-assign",
  "total_par": "Total Par",
  "par_distribution": "Par Distribution",
  "par_3": "Par 3",
  "par_4": "Par 4",
  "par_5": "Par 5",
  "par_6": "Par 6",
  "tee_set_configuration": "Tee Set Configuration",
  "at_least_one_tee_set": "At least one tee set is required",
  "add_tee_set": "Add Tee Set",
  "tee_name": "Tee Name",
  "color": "Color",
  "black": "Black",
  "gold": "Gold",
  "blue": "Blue",
  "white": "White",
  "yellow": "Yellow",
  "red": "Red",
  "green": "Green",
  "orange": "Orange",
  "purple": "Purple",
  "championship": "Championship",
  "tee_set": "Tee Set",
  "select_tee_set": "Select tee set",
  "course_rating_male": "CR (Male)",
  "slope_rating_male": "Slope (Male)",
  "course_rating_female": "CR (Female)",
  "slope_rating_female": "Slope (Female)",
  "hole_distances": "Hole Distances (meters)",
  "total_distance": "Total Distance",
  "meters": "meters",
  "remove_tee_set": "Remove Tee Set",
  "review_confirm": "Review & Confirm",
  "review_configuration": "Please review your scorecard configuration before saving",
  "coordinates": "Coordinates",
  "hcp": "HCP",
  "confirm_delete_scorecard": "Are you sure you want to delete this scorecard?",
  "scorecard_created_successfully": "Scorecard created successfully",
  "scorecard_updated_successfully": "Scorecard updated successfully",
  "scorecard_deleted_successfully": "Scorecard deleted successfully",
  "status_updated_successfully": "Status updated successfully",
  "failed_to_load_scorecards": "Failed to load scorecards",
  "failed_to_load_scorecard_details": "Failed to load scorecard details",
  "failed_to_save_scorecard": "Failed to save scorecard",
  "failed_to_delete_scorecard": "Failed to delete scorecard",
  "failed_to_update_status": "Failed to update status",
  "no_holes_configured": "No holes configured yet. Click 'Initialize Holes' to create them.",
  "initialize_holes": "Initialize Holes",
  "scorecards_activated": "{{count}} scorecards activated",
  "scorecards_deactivated": "{{count}} scorecards deactivated",
  "scorecards_deleted": "{{count}} scorecards deleted",
  "failed_to_activate": "Activation failed",
  "failed_to_deactivate": "Deactivation failed",
  "failed_to_delete_scorecards": "Failed to delete scorecards",
  "delete_scorecards": "Delete scorecards",
  "confirm_delete_scorecards": "Are you sure you want to delete {{count}} scorecards?",
  "owner_tenant": "Owner club",
  "no_owner": "No owner",
  "owned_by": "Owner: {{name}}",
  "visible_to_other_tenants": "Visible to other clubs",
  "shared_with": "Visible to clubs: {{names}}",
  "shared_tenants": "Visibility to other clubs",
  "shared_tenants_placeholder": "Select clubs...",
  "import_ebirdie": "Import from eBirdie",
  "import_ebirdie_title": "Import course from eBirdie",
  "import_ebirdie_confirm": "Import",
  "import_ebirdie_failed": "Importing course from eBirdie failed",
  "select_tenant": "Select club",
  "ebirdie_course": "eBirdie course",
  "search_ebirdie_courses": "Search by course or club name...",
  "select_ebirdie_course": "Select course",
  "no_shared_tenants_available": "No options available"
}
